'use strict';

var React = require('react');

var InlineInfoMessage = React.createClass({
    propTypes: {
        message: React.PropTypes.string.isRequired,
        isHidden: React.PropTypes.bool.isRequired
    },
    getDefaultProps: function () {
        return {
            isHidden: true
        };
    },
    render: function () {
        if (!this.props.message) {
            return null;
        }
        if (!this.props.isHidden) {
            return (<div className="help-text-popup">
                            <div className="help-text-popup__inner">
                                <p dangerouslySetInnerHTML={{__html: this.props.message}} />
                            </div>
                        </div>); 
        }
        return null;
    }
});

module.exports = InlineInfoMessage;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/InlineInfoMessage.jsx